export default __webpack_public_path__ + "static/0028-3210a8f2920c1d424179c3aa18cb1ce0.png";